<template>
  <div class="c-vorder-summary">

    <JsonViewer
        v-if="false"
        :value="{
          PRIZE_ID: attrs.PRIZE_ID,
          COUPON_ID: attrs.COUPON_ID,
          discountBenefitsStandalone,
        }"
    />

    <div class="q-gutter-y-sm">

      <!-- Подарки из BasketRules -->
      <BasketRulesGiftsSummary/>

      <template v-if="benefitType === 'discount' && discountBenefitsStandaloneBest">
        <div class="c-line text-weight-medium">
          <div class="c-line__title s-font-xs">
            {{ discountBenefitsStandaloneBest.rule.NAME }}
          </div>
          <div class="c-line__value s-font-xs">
            {{ discountBenefitsStandaloneBest.DISCOUNT_PERCENT }}%
          </div>
        </div>
      </template>
      <template v-else-if="benefitType === 'bonus'">
        <div class="c-line text-weight-medium">
          <div class="c-line__title s-font-xs">
            Использовать бонусы
          </div>
          <div class="c-line__value s-font-xs">
            <b>{{ bonuses }}</b>
          </div>
        </div>
      </template>
      <template v-else-if="benefitType === 'coupon' && isCouponActive && coupon">
        <div class="c-line text-weight-medium">
          <div class="c-line__title s-font-xs">
            Промокод
          </div>
          <div class="c-line__value s-font-xs">
            {{ coupon.NAME }}
          </div>
        </div>
      </template>

      <div class="c-line" v-if="deliveryPriceDiscounted">
        <div class="c-line__title s-font-sm">
          Стоимость доставки:
        </div>
        <div class="c-line__value s-font-sm">
          <AnimatedNumber
              :number="deliveryPriceDiscounted"
              append=" ₽"
          />
        </div>
      </div>

      <div class="c-line text-weight-bold" v-if="!basketIsEmpty">
        <div class="c-line__title s-font-sm">
          Итого к оплате
        </div>
        <div class="c-line__value s-font-sm">
          <AnimatedNumber
              :number="pricePay"
              append=" ₽"
          />
          <span
              v-if="pricePay < pricePaySource"
              class="price-old q-ml-sm"
          >{{ pricePaySource }} ₽</span>
        </div>
      </div>

    </div>

  </div>
</template>

<script setup lang="ts">
import BasketRulesGiftsSummary from "@/components/Shop/VOrder/ui/BasketRulesGiftsSummary.vue";
import AnimatedNumber from "@/components/Ui/AnimatedNumber.vue";
import {useDebugComponent} from "@/core/composable/useDebugComponent";
import {useFortuneStore} from "@/modules/fortune/store/fortune";
import {useBasketStore} from "@/modules/shop/store/basket";
import {useBasketRulesStore} from "@/modules/shop/store/basket-rules";
import {useVorderCoupon} from "@/modules/shop/store/vorder-coupon";
import {useVorderState} from "@/modules/shop/store/vorder-state";
import {useVorderTotalStore} from "@/modules/shop/store/vorder-total";
import {storeToRefs} from "pinia";

const vorderTotal = useVorderTotalStore()
const vorderState = useVorderState()
const vorderCoupon = useVorderCoupon()
const basketStore = useBasketStore()
const fortuneStore = useFortuneStore()
const basketRulesStore = useBasketRulesStore()

const {
  isCouponActive,
  coupon
} = storeToRefs(vorderCoupon)

const {
  discountBenefitsStandalone,
  discountBenefitsStandaloneBest,
  deliveryPriceDiscounted
} = storeToRefs(basketRulesStore)

const {
  attrs,
  bonuses,
  benefitType
} = storeToRefs(vorderState)

const {pricePay, pricePaySource} = storeToRefs(vorderTotal)

const props = withDefaults(defineProps<{}>(), {})

const {basketIsEmpty} = storeToRefs(basketStore)


// Debug композабл для отслеживания ререндеров
useDebugComponent('VOrderSummary', {collectRenders: true});


</script>

<style scoped lang="scss">

.c-line {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 10px;
  align-items: center;
}

.c-line__title {

}

.c-line__value {
  margin-right: auto;
  flex-grow: 1;
  text-align: right;
}

.c-delivery-select {

}

.c-delivery-btn {
  max-height: none;
  padding: 4px 9px;
  width: 100%;

  &.q-btn--outline:before {
    border1: 1px dashed #cccccc;
  }

  &.--big-text {
    :deep(.block) {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      text-align: right;
    }
  }

  &.--value-empty {
    :deep(.block) {

    }
  }
}


</style>
